export default {
  document: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  nomeAssociado: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numSisbr: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numeroPA: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  gerenteSisbr: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  gerenteRelecionamento: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  clusterizacao: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  nomeRegional: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  grupoEconomico: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  situacaoContaCapital: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  estado: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  cidade: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/campaign/campaignlist/components/add/modal/advancedcontactmodal/advancecontact-form.js